exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.detail-button {\r\n    font-size: 18px !important;\r\n    color: #1c869a;\n}\n.detail-button:hover {\r\n    color: #0c4955;\r\n    transition: 0.5s;\n}\r\n", ""]);

// exports
